module.exports = __webpack_public_path__ + "img/back_button_no_text.425cfc37.png";